import { bootstrapApplication } from '@angular/platform-browser';
import { AppAdminComponent } from './app/app';
import { appConfig } from './app/app.config';

bootstrapApplication(AppAdminComponent, appConfig).catch((err) => console.error(err));
